import { fetch, handleApiError } from '../utils/http';
import { apiUrl } from '../config';

const DASH_PERFORMANCE = 'HOME_PERFORMANCE';


function genericFetchAction(actionName, event, data, error) {
    let action = {
        type : actionName + '_' + event.toUpperCase()
    };
    if(data) {
        action.data = data;
    }
    if(error) {
        action.error = error;
    }
    return action;
}


export function fetchPerformanceReport(params) {
    return (dispatch) => {
        dispatch(genericFetchAction(DASH_PERFORMANCE, 'START'));
        const url = `${apiUrl()}/reports/performance`;
        fetch(url, {
            method : 'GET',
            queryParams: params
        })
            .then(response => response.json())
            .then(data => dispatch(genericFetchAction(DASH_PERFORMANCE, 'SUCCESS', data)))
            .catch(error => handleApiError(error, dispatch, (error) => genericFetchAction(DASH_PERFORMANCE, 'FAILURE', null, error)));
    }      
}


/** WEBPACK FOOTER **
 ** ./src/actions/home.js
 **/